export default __webpack_public_path__ + "static/media/vergne11-12.7e2cf8b0.png";